<template>
  <div class="mb-8">
    <v-btn small outlined color="primary" @click="openSubstituteDialog"> Quản lý dạy thay </v-btn>
    <v-dialog v-model="dialog" max-width="500px">
      <BaseBodyDialog title="Quản lý dạy thay" :loading="loading" @close="closeDialog" @save="saveSubstitutes">
        <AutocompleteTeacherCard
          v-model="substituteTeachers"
          class="mt-6"
          label="Chọn giáo viên dạy thay"
          outlined
          dense
          multiple
          :filter="teacherFilter"
          @change="onTeachersChange"
        />
      </BaseBodyDialog>
    </v-dialog>
  </div>
</template>

<script>
import AutocompleteTeacherCard from '@/components/basic/input/AutocompleteTeacherCard.vue'
import BaseBodyDialog from '@/components/basic/dialog/BaseBodyDialog.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    AutocompleteTeacherCard,
    BaseBodyDialog,
  },
  props: {
    lesson: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      substituteTeachers: [],
      teacherFilter: {},
      loading: false,
    }
  },
  computed: {
    ...mapGetters('class', ['getSelectedClass']),
  },
  methods: {
    ...mapActions('lesson', ['updateTeachers']),
    openSubstituteDialog() {
      this.dialog = true
      this.substituteTeachers = this.lesson.teachers
      const selectedClass = this.getSelectedClass
      if (selectedClass && selectedClass.academicLevel) {
        this.teacherFilter = { academicLevels: selectedClass.academicLevel }
      }
    },
    closeDialog() {
      this.dialog = false
      this.substituteTeachers = []
      this.teacherFilter = {}
    },
    async saveSubstitutes() {
      if (this.substituteTeachers.length > 0) {
        this.loading = true
        try {
          await this.updateTeachers({
            id: this.lesson.id,
            params: { teachers: this.substituteTeachers.map((teacher) => teacher.id) },
          })
          this.$emit('update:lesson', { ...this.lesson, teachers: this.substituteTeachers })
          this.closeDialog()
        } finally {
          this.loading = false
        }
      }
    },
    onTeachersChange(teachers) {
      this.substituteTeachers = teachers
    },
  },
}
</script>
